import { api } from '@/utils'

export default {
	fetchLeads ({ commit, getters, rootGetters }) {
		if (!rootGetters.connected) {
			return
		}

		commit('loading', 'monsterleads', { root: true })
		commit('resetLeads')
		return api.get('leads' + getters.leadsQueryString).then((response) => {
			commit('doneLoading', 'monsterleads', { root: true })
			commit('setLeadsPageData', response.body)
		})
	},

	deleteLead ({ commit, state }, leadId) {
		const lead = Array.from(state.leads).find(lead => leadId === lead.id)
		if (confirm(`Are you sure you want to delete ${lead.email}?`)) {
			api.delete(`leads/${leadId}`)
				.then(() => {
					commit('removeLead', leadId)
				})
		}
	},

	updateSiteFilters ({ commit, state, dispatch }, siteData) {
		commit('updateSiteFilters', siteData)
		dispatch('fetchLeads')
	},

	updateCampaignFilters ({ commit, state, dispatch }, campaignData) {
		commit('updateCampaignFilters', campaignData)
		dispatch('fetchLeads')
	},

	updateTagFilters ({ commit, state, dispatch }, tagData) {
		commit('updateTagFilters', tagData)
		dispatch('fetchLeads')
	},

	updateStartDate ({ commit, state, dispatch }, dateString) {
		commit('updateStartDate', dateString)
		dispatch('fetchLeads')
	},

	updateEndDate ({ commit, state, dispatch }, dateString) {
		commit('updateEndDate', dateString)
		dispatch('fetchLeads')
	},

	updateSearch ({ commit, state, dispatch }, search) {
		commit('setSearch', search)
		dispatch('fetchLeads')
	},

	changePage ({ commit, state, dispatch }, page) {
		commit('setPage', page)
		dispatch('fetchLeads')
	},
}
